export const PassengerGroups = Object.freeze({
  ADULT: 'ADULT',
  CHILD: 'CHILD',
  INFANT: 'INFANT',
  LAP_INFANT: 'LAP_INFANT',
  SEAT_INFANT: 'SEAT_INFANT',
  MILITARY: 'MILITARY',
  SENIOR_CITIZEN: 'SENIOR_CITIZEN',
})
